// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__lBBp6","waves":"banner_waves__WrVJQ","children":"banner_children__0YVpO"};